// import firebase from "firebase/app"
// import "firebase/messaging"
// import 'firebase/firestore'

// firebase.initializeApp({
//   apiKey: "AIzaSyCwTTboW4gsuzVrmVxImXGvg0dOkVaPXww",
//   authDomain: "umb-amanata.firebaseapp.com",
//   projectId: "umb-amanata",
//   storageBucket: "umb-amanata.appspot.com",
//   messagingSenderId: "316106460576",
//   appId: "1:316106460576:web:65334ed60787dc5b6f68c5",
//   measurementId: "G-0YLP1E3722"
// })

// if (!firebase.apps.length) {
//   firebase.initializeApp(config)
// }

// navigator.serviceWorker
//   .register("firebase-messaging-sw.js", {
//     scope: "firebase-cloud-messaging-push-scope",
//   })
//   .then((registration) => {
//     const messaging = firebase.messaging()

//     messaging.useServiceWorker(registration)
//   })
//   .catch((err) => {
//     console.log(err)
//   })

// export const db = firebase.firestore()

// export default firebase


import firebase from 'firebase'

const config = {
  apiKey: "AIzaSyCwTTboW4gsuzVrmVxImXGvg0dOkVaPXww",
  authDomain: "umb-amanata.firebaseapp.com",
  projectId: "umb-amanata",
  storageBucket: "umb-amanata.appspot.com",
  messagingSenderId: "316106460576",
  appId: "1:316106460576:web:65334ed60787dc5b6f68c5",
  measurementId: "G-0YLP1E3722"
}

if (!firebase.apps.length) {
  firebase.initializeApp(config)
}

const messaging = firebase.messaging()

messaging.usePublicVapidKey("BHdIf5oZD02isSooCDR6X1V2WC9b70iX-oVvKG5OKIpcECTzseauzAnmMQZcMaDakSKHv8wsZ2mZ11ItRepuOoA")

export default firebase